import { Button, ButtonProps } from "antd";
import { useContext } from "react";
import { GLOB } from "src/util/Glob";
import { AllItemsContext } from "../comp/AllItems";
import { invalidHwProps } from "../XmRule";

const AddButton = ({ disabled, ...rest }: ButtonProps) => {
  const { cls, subsystem, hw_type } = useContext(AllItemsContext);
  const invalidBaseProps = invalidHwProps({ cls, hw_type, subsystem });
  const { readonly } = GLOB.userInfo;
  const isDisabled = readonly || invalidBaseProps || disabled;

  return <div className='xm-rule-controllers-footer'>
    <Button className='xm-add-item-btn' size='small' disabled={isDisabled} {...rest}>Add Item</Button>
  </div>;
};

export default AddButton;
